// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AliwangwangOutlinedSvg from "@fishx/icons-svg/es/asn/AliwangwangOutlined";
import FishxIcon from '../components/FishxIcon';

var AliwangwangOutlined = function AliwangwangOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AliwangwangOutlinedSvg
  }));
};

AliwangwangOutlined.displayName = 'AliwangwangOutlined';
export default React.forwardRef(AliwangwangOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AliwangwangOutlined.js
// module id = 1971
// module chunks = 0